import React from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarFooter,
  SidebarContent,
} from 'react-pro-sidebar';
import { FaHome, FaUserTie, FaCog, FaFileInvoice} from 'react-icons/fa';
import bgImage from './../../../images/bg1.jpg'

export class Aside extends React.Component{

    handleToggleSidebar(e){
        this.props.mapState("ASIDE_TOGGLER", !this.props.asideToggled)
    }


    logout = () => {
        this.props.history.replace("/")       
        sessionStorage.clear()
    }

    render(){
        return (
            <ProSidebar
                rtl={false}
                image={this.props.asideBgImage ? bgImage : ""}
                collapsed={this.props.asideColapsed}
                toggled={this.props.asideToggled}
                breakPoint="md"
                onToggle={(e) => this.handleToggleSidebar(e)}        
                className="pro-sidebar-color"
                id="pro-sidebar"               
            >
                <SidebarContent>
                    <Menu iconShape="circle">
                        <MenuItem
                            icon={<FaHome size={24}/>}
                            //suffix={<span className="badge red">Novo</span>}
                        >
                            <Link to="/Client/dashboard" onClick={(e) => this.handleToggleSidebar(e)}>Opći podaci</Link>
                        </MenuItem>
                    
                        <MenuItem
                            icon={<FaUserTie size={24}/>}
                            //suffix={<span className="badge red">Novo</span>}
                        >
                            <Link to="/Client/racuni" onClick={(e) => this.handleToggleSidebar(e)}>Računi</Link>
                        </MenuItem>

                        <MenuItem
                            icon={<FaFileInvoice size={24}/>}
                            //suffix={<span className="badge red">Novo</span>}
                        >
                            <Link to="/Client/izvjestaji" onClick={(e) => this.handleToggleSidebar(e)}>Izvještaji</Link>
                        </MenuItem>

                        <MenuItem icon={<FaCog size={24}/>}> 
                            <Link to="/Client/settings" onClick={(e) => this.handleToggleSidebar(e)}>Postavke</Link>
                        </MenuItem>

                    </Menu>
                </SidebarContent>

                <SidebarFooter style={{ textAlign: 'center' }}>
            
                </SidebarFooter>
            </ProSidebar>
        );
    };
}


const mapStateToProps = state => {
  return {
      userLoggedIn: state.client.userLoggedIn,
      asideBgImage: state.clientSettings.asideBg,
      asideColapsed: state.clientSettings.asideColapsed,
      asideToggled: state.clientSettings.asideToggled
  };
};

const mapDispatchToProps = dispatch => {
  return {
    mapState: (type, data) => dispatch({ type: type, data: data})
  };
};



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Aside);

